// extracted by mini-css-extract-plugin
export default {"recos":"D2-z","productCardOverride":"E2-z","rowHasBadge":"F2-z"};